import styled from 'styled-components';
import { FONT_FAMILY, COLORS } from '@Commons';

export const ApplePayModalContainer = styled.div`
  display: flex;
  border-radius: 10px;
  background-color: ${COLORS.white};
  width: 100%;
  max-width: 350px;
  padding: 32px 24px;
  .apple-pay-retry-modal__content {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 24px;
    .apple-pay-retry-modal__title {
      font-weight: 700;
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0;
      text-align: center;
    }
    .apple-pay-retry-modal__message {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0;
      text-align: center;
      color: ${COLORS.textGrey};
    }
    .apple-pay-retry-modal__button {
      width: 100% !important;
      min-height: inherit !important;
    }
  }
`;
